
































































































































import { Vue, Component } from 'vue-property-decorator';
import {
  EventNew, PartnersApi, MarketsApi,
} from '@compassdigital/foodworks.ts.sdk';
import RestaurantsList from '@/components/Form/Scheduler/RestaurantsList/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import ScheduleUtil from '@/util/ScheduleUtil';
import AppModule from '@/store/modules/app';
import Format from '@/util/Format';
import ToastModule from '@/store/modules/toast';
import MarketUtil from '@/util/MarketUtil';
import moment from 'moment';

@Component({
  components: {
    RestaurantsList,
    PrimaryButton,
  },
})
export default class publishRestaurants extends Vue {
  public monthCalendar: any = '';

  public eventMeta: EventNew[] = [];

  public partnersInMarket: any = {};

  public saving: boolean = false;

  public partnerUserId: string = '';

  public publishPartnerDate: string = '';

  public eventPartners: EventNew[] = [];

  public error: string = '';

  public start: any = '';

  public end: any = '';

  public loading: boolean = false;

  public partnerPublishUser: boolean = true;

  public disablePartners: boolean = false;

  public partnerName: string = '';

  public marketID: string = '';

  public mounted() {
    const {
      partners, monthDay, publishDate, marketID,
    } = this.$route.params;
    if (partners) {
      this.partnersInMarket = partners;
      this.monthCalendar = monthDay;
      this.publishPartnerDate = publishDate;
      this.start = publishDate;
      this.end = publishDate;
      this.marketID = marketID;
      this.getPartnersInMarket();
    }
  }

  public eventHiehgt: number = 50;

  public async onChangePartner(value: any) {
    try {
      this.partnerUserId = value;
      this.disablePartners = true;
      this.saving = true;
      const startDate = moment().startOf('month').subtract(1, 'year').format('YYYY-MM-DD');
      const endDate: string = moment().endOf('month').add(2, 'year').format('YYYY-MM-DD');
      const nullDate: any = undefined;
      const api = new PartnersApi(AppModule.apiConfig);
      const partnerUser = await api.getPartnerEvents(
        value, nullDate, startDate, endDate,
      );
      if (partnerUser.data) {
        this.eventPartners = partnerUser.data;
        this.eventMeta = ScheduleUtil.getPartnerRoleEvents(partnerUser.data);
        const publishPartnerEvents = ScheduleUtil.getPublishedEvents(
          partnerUser.data, this.publishPartnerDate,
        );
        if (publishPartnerEvents.length > 0) {
          this.partnerPublishUser = false;
        } else {
          this.partnerPublishUser = true;
        }
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.disablePartners = false;
    this.saving = false;
  }

  public onChangePartnerName(name: string) {
    this.partnerName = name;
  }

  public async onSubmitEvents() {
    try {
      this.loading = true;
      const date = Format.getSchedulerDate(this.publishPartnerDate);
      const api = new PartnersApi(AppModule.apiConfig);
      const events = await api.postPartnerEvents(
        this.partnerUserId, date,
      );
      if (events.data) {
        this.partnerPublishUser = true;
        const partnerName = `Published draft events to ${this.partnerName}`;
        if (partnerName) {
          ToastModule.setToast({
            message: `${partnerName}`,
            timeout: 5000,
          });
        }
        this.getPartnersInMarket();
        this.onChangePartner(this.partnerUserId);
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  public closePublishPartners() {
    this.$router.push(`${this.marketID}`);
  }

  public async getPartnersInMarket() {
    try {
      this.saving = true;
      this.disablePartners = true;
      const api = new MarketsApi(AppModule.apiConfig);
      const fetchedPartners = await api.getPartnersInMarketId(this.marketID);
      if (fetchedPartners) {
        const updateData: any = ScheduleUtil.activePartners(fetchedPartners.data as any);
        const mappedPartnerMarket = MarketUtil.getMappedMarkets(updateData);
        const restaurantsInMarket = mappedPartnerMarket;
        this.partnersInMarket = await ScheduleUtil.getAsteriskEvents(
          restaurantsInMarket, this.start,
        );
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.disablePartners = false;
    this.saving = false;
  }
}
